
import React, { useContext } from "react";
import { BiEdit, BiListCheck, BiSolidFilterAlt, BiSolidFolderOpen } from "react-icons/bi";
import { BsFillDatabaseFill, BsFillLightbulbFill, BsHandThumbsUpFill, BsImages } from "react-icons/bs";
import esg_ai_pic from "../../../images/esg_ai_Green.png";
import { withTranslation } from "react-i18next";
import { PollerContext } from "../../../App";
import { AIReportJobStatus, PollerAction } from "../../../core/constants/common";
import ReportService from "../../../core/service/ReportService";

function ReportGenProgressCard({ t, reportName = '', stateCount = 8 }) {

	const { pollerData, setPollerData } = useContext(PollerContext);

	let inProgressPart = 0;
	if (pollerData.progress) {
		const progessSplit = pollerData.progress.split('/');
		const numerator = progessSplit[0];
		const denominator = progessSplit[1];
		inProgressPart = Math.round((+numerator * 100 * stateCount) / (+denominator * 100));
		if (inProgressPart > stateCount) {
			inProgressPart = stateCount;
		}
	}

	const onStopGeneration = () => {
		ReportService.updateJobStatus(pollerData.jobId, 3).then(res => {
			if (res.status !== 200) return;

		}).catch(err => { });
		setPollerData({
			...pollerData,
			jobId: 0,
			action: PollerAction.STOP,
			status: AIReportJobStatus.FAILED,
			progress: ''
		});
	};


	return (
		<div className="card AI_generating_card">
			<div className="card-body p-0">
				<div className="AI_generating_card_head p-2">
					<div className="AI_loaderbox">
						<div className="spinner-8"></div>
					</div>
					<div>
						<h4>
							{
								stateCount === 8
									?
									<>
										<img src={esg_ai_pic} />
										<span>ESGAI® Copilot </span> {t('GeneratingReport.label')}
									</>
									:
									<div>{t('ReportGenProgressCard.preparingToLoad.label')}</div>
							}
						</h4>
						{
							stateCount === 4 &&
							<>
								<p>{reportName}</p>
								<h6 className=""><strong>{t('ReportGenProgressCard.completionMessage.label')}</strong></h6>
							</>
						}
					</div>
				</div>
				<div className="AI_generating_card_body">
					<div className="AI_generating_Wizards_box">
						{
							stateCount === 8 &&
							<ul>
								<li className={inProgressPart === 1 ? 'selected' : inProgressPart > 1 ? 'done' : ''}>
									<div><BsFillLightbulbFill /></div>
									<span>{t('ReportGenProgressCard.ideating.label')}</span>
								</li>
								<li className={inProgressPart === 2 ? 'selected' : inProgressPart > 2 ? 'done' : ''}>
									<div><BsFillDatabaseFill /> </div>
									<span>{t('ReportGenProgressCard.gatheringData.label')} </span>
								</li>
								<li className={inProgressPart === 3 ? 'selected' : inProgressPart > 3 ? 'done' : ''}>
									<div><BiSolidFolderOpen /> </div>
									<span>{t('ReportGenProgressCard.organizingInsights.label')}</span>
								</li>
								<li className={inProgressPart === 4 ? 'selected' : inProgressPart > 4 ? 'done' : ''}>
									<div><BiEdit /> </div>
									<span>{t('ReportGenProgressCard.craftingDraft.label')}</span>
								</li>
								<li className={inProgressPart === 5 ? 'selected' : inProgressPart > 5 ? 'done' : ''}>
									<div><BiSolidFilterAlt /> </div>
									<span>{t('ReportGenProgressCard.refining.label')}</span>
								</li>
								{!!pollerData.reportType && pollerData.reportType == "GRI" ?
									<li className={inProgressPart === 6 ? 'selected' : inProgressPart > 6 ? 'done' : ''}>
										<div><BsImages /> </div>
										<span>{t('ReportGenProgressCard.addingVisuals.label')} </span>
									</li> : ""}
								<li className={inProgressPart === 7 ? 'selected' : inProgressPart > 7 ? 'done' : ''}>
									<div><BiListCheck /> </div>
									<span>{t('ReportGenProgressCard.lastCheck.label')}</span>
								</li>
								<li className={inProgressPart === 8 ? 'selected' : inProgressPart > 8 ? 'done' : ''}>
									<div><BsHandThumbsUpFill /> </div>
									<span>{t('ReportGenProgressCard.ready.label')}</span>
								</li>
							</ul>
						}
						{
							stateCount === 4 &&
							<ul>
								<li className='done'>
									<div><BsFillDatabaseFill /> </div>
									<span>{t('ReportGenProgressCard.gatheringData.label')} </span>
								</li>
								<li className={inProgressPart === 1 ? 'selected' : (inProgressPart > 1 || pollerData.status === AIReportJobStatus.COMPLETED) ? 'done' : ''}>
									<div><BiSolidFolderOpen /> </div>
									<span>{t('ReportGenProgressCard.organizingInsights.label')}</span>
								</li>
								<li className={inProgressPart === 2 ? 'selected' : (inProgressPart > 2 || pollerData.status === AIReportJobStatus.COMPLETED) ? 'done' : ''}>
									<div><BiEdit /> </div>
									<span>{t('ReportGenProgressCard.creatingDisclosure.label')}</span>
								</li>
								<li className={inProgressPart === 3 ? 'selected' : (inProgressPart > 3 || pollerData.status === AIReportJobStatus.COMPLETED) ? 'done' : ''}>
									<div><BiListCheck /> </div>
									<span>{t('ReportGenProgressCard.lastCheck.label')}</span>
								</li>
								<li className={inProgressPart === 4 ? 'selected' : (inProgressPart > 4 || pollerData.status === AIReportJobStatus.COMPLETED) ? 'done' : ''}>
									<div><BsHandThumbsUpFill /> </div>
									<span>{t('ReportGenProgressCard.ready.label')}</span>
								</li>
							</ul>
						}
					</div>
					<div className="p-3">
						{stateCount === 8 && <p className="mb-2">{t('ESGAIReportGenLoaderHelper.label')}</p>}
						<button className="btn btn-secondary" onClick={() => onStopGeneration()}>{t('ReportGenProgressCard.stopGenerating.label')}</button>
					</div>
				</div>
			</div>
		</div>
	);
}

export default withTranslation()(ReportGenProgressCard);